import React from 'react';
import { IMaskInput } from 'react-imask';
import { MaskedRange } from 'imask';
import { IMaskMixin } from 'react-imask';

export interface MaskedInput extends IMaskInput {}
export interface MaskRange extends MaskedRange {}
export interface MaskMixin extends IMaskMixin {}

export const MaskedInput = (props) => {
  return <IMaskInput {...props} />
}

export const MaskRange = MaskedRange;
export const MaskMixin = IMaskMixin;

export default MaskedInput;
